module.exports = "/images/vendor/flag-icon-css/flags/1x1/sc.svg?ad1bcb4c714e0ca8c7355ecd4b0c3cbb";